/*
 * Stain Lift article enhancements (loaded by sections/main-article.liquid only).
 * 1. Auto table of contents from the H2s in the article body.
 * 2. Copy-link button in the share strip.
 * No dependencies. Safe to run more than once (theme editor reloads).
 */
(function () {
  'use strict';

  function slugify(text) {
    var s = String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    s = s
      .replace(/[\u2018\u2019']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || 'section';
  }

  function uniqueId(base, doc) {
    var id = base;
    var n = 2;
    while (doc.getElementById(id)) {
      id = base + '-' + n;
      n += 1;
    }
    return id;
  }

  function buildToc(root, doc) {
    doc = doc || document;
    if (!root || root.hasAttribute('data-sl-toc-built')) return null;
    var min = parseInt(root.getAttribute('data-sl-toc-min'), 10) || 3;
    var label = root.getAttribute('data-sl-toc-label') || 'Contents';
    var headings = Array.prototype.slice.call(root.querySelectorAll('h2')).filter(function (h) {
      return h.textContent.trim().length > 0;
    });
    root.setAttribute('data-sl-toc-built', '');
    root.setAttribute('data-sl-toc-count', String(headings.length));
    if (headings.length < min) return null;

    var nav = doc.createElement('nav');
    nav.className = 'sl-toc';
    nav.setAttribute('aria-labelledby', 'sl-toc-title');
    var title = doc.createElement('p');
    title.className = 'sl-toc__title';
    title.id = 'sl-toc-title';
    title.textContent = label;
    var list = doc.createElement('ol');
    list.className = 'sl-toc__list';

    headings.forEach(function (h) {
      if (!h.id) h.id = uniqueId(slugify(h.textContent), doc);
      h.classList.add('sl-toc-target');
      var li = doc.createElement('li');
      var a = doc.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.appendChild(title);
    nav.appendChild(list);

    // Place after the first one or two intro paragraphs that come before the first H2.
    var first = headings[0];
    var anchor = null;
    var count = 0;
    var node = root.firstElementChild;
    while (node && node !== first && !node.contains(first) && count < 2) {
      if (node.tagName === 'P' && node.textContent.trim().length > 0) {
        anchor = node;
        count += 1;
      }
      node = node.nextElementSibling;
    }
    if (anchor) {
      anchor.parentNode.insertBefore(nav, anchor.nextSibling);
    } else if (first.parentNode === root) {
      root.insertBefore(nav, first);
    } else {
      root.insertBefore(nav, root.firstChild);
    }
    return { count: headings.length, nav: nav };
  }

  function initCopy(doc) {
    doc = doc || document;
    var buttons = doc.querySelectorAll('[data-sl-copy]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var item = btn.closest('.sl-share__copy-item');
      if (!navigator.clipboard || !item) return;
      item.hidden = false;
      if (btn.hasAttribute('data-sl-copy-ready')) return;
      btn.setAttribute('data-sl-copy-ready', '');
      btn.addEventListener('click', function () {
        var status = item.querySelector('.sl-share__status');
        navigator.clipboard.writeText(btn.getAttribute('data-sl-copy')).then(
          function () {
            if (status) status.textContent = 'Link copied';
            setTimeout(function () { if (status) status.textContent = ''; }, 2500);
          },
          function () {
            if (status) status.textContent = 'Copy failed';
          }
        );
      });
    });
  }

  function init() {
    var roots = document.querySelectorAll('.sl-article [data-sl-toc-source]');
    Array.prototype.forEach.call(roots, function (r) { buildToc(r, document); });
    initCopy(document);
  }

  if (typeof window !== 'undefined') {
    window.SLArticle = { slugify: slugify, buildToc: buildToc, initCopy: initCopy };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  }
})();
